import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';

import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';

@Component({
  selector: 'app-sms-notification-consent',
  templateUrl: './sms-notification-consent.component.html',
  styleUrls: ['./sms-notification-consent.component.scss']
})
export class SmsNotificationConsentComponent implements OnInit {
  @Input() isCreateAccountMode: boolean;
  @Input() formGroup: FormGroup;

  brandName: string;
  phoneForm: FormGroup;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.Canada];
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;

  constructor(
    private configHelper: ConfigHelper
  ) {
  }

  ngOnInit(): void {
    this.brandName = this.configHelper.getBrandName();
  }

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.Canada];
  }
}
